const searchFieldsIcd10 = {
	name_norwegian: {
		weight: 3,
	},
	snomed_synonyms: {
		weight: 6,
	},
	code: {
		weight: 4,
	},
	compact_code: {
		weight: 1,
	},
	code_system: {
		weight: 1,
	},
	code_values: {
		weight: 1,
	},
	inclusion: {
		weight: 1,
	},
	notes: {
		weight: 1,
	},
	chapter_code: {
		weight: 1,
	},
}

export default searchFieldsIcd10
